import React from 'react';
import {OrbitComponent} from '../../../../base-components/orbit-component/orbit-component';
import {GameBadgeBox} from '../../boxes/game-badge/game-badge.box';

export interface GameBadgeComponentProps {
  badgeUrl?: string;
  squareIcon?: boolean;
}


export class GameBadgeComponent extends OrbitComponent<GameBadgeComponentProps> {

  render() {
    if(this.services.device.hybrid.isEmbedded) {
      return null;
    }

    if(this.props.badgeUrl) {
      return (
          <GameBadgeBox lazy src={this.props.badgeUrl} className='cy-game-badge'/>
      );
    }
    return null;
  }
}
